var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:(_vm.themeInverted)},[_c('v-main',[_c('enable-notifications'),_c('router-view'),_c('router-view',{attrs:{"name":"login"}}),_c('notifications',{attrs:{"position":"bottom right"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }